import { AfterViewInit, Component, ElementRef, HostListener, OnDestroy, Renderer2, ViewChild } from '@angular/core';

@Component({
  selector: 'app-acessibilidade-portal',
  standalone: false,
  templateUrl: './acessibilidade-portal.component.html',
  styleUrl: './acessibilidade-portal.component.css'
})
export class AcessibilidadePortalComponent implements AfterViewInit, OnDestroy {
  constructor(
    private elRef: ElementRef,
    private renderer: Renderer2) {
  }
  showBotaoTopo = false;

  ngAfterViewInit() {
    this.hostEl = this.elRef.nativeElement.querySelector('.accessibility-menu');

    if (this.hostEl && document.body) {
      this.renderer.appendChild(document.body, this.hostEl);
      this.renderer.setStyle(this.hostEl, 'position', 'fixed');
      this.renderer.setStyle(this.hostEl, 'right', '12px');
      this.renderer.setStyle(this.hostEl, 'top', '67%');
      this.renderer.setStyle(this.hostEl, 'transform', 'translateY(-67%)');
      this.renderer.setStyle(this.hostEl, 'z-index', '2147483647');
    }

    // inicializar tooltip
    this.initTooltip();

    //voltar ao topo
    setTimeout(() => {
      document.body.classList.remove('modal-open');
      document.querySelectorAll('.modal-backdrop').forEach(b => b.remove());
    }, 0);
  }

  private tooltipEl!: HTMLElement;
  private hideTimeout: any = null;

  private initTooltip() {
    const icon = this.accessibilityIcon.nativeElement as HTMLElement;

    this.tooltipEl = this.renderer.createElement('div');
    this.tooltipEl.className = 'accessibility-tooltip';
    this.tooltipEl.innerHTML = `
    <!--<img src="/assets/images/acessibilidade-ilustracao.jpg" style="width: 35px; height: 35px;"  />-->
    <div class="label">
        <div style="font-size: 14px">Acessibilidade</div>
     </div>
`;
    this.renderer.appendChild(document.body, this.tooltipEl);
    this.renderer.setStyle(this.tooltipEl, 'position', 'fixed');
    this.renderer.setStyle(this.tooltipEl, 'z-index', '2147483647');
    this.renderer.setStyle(this.tooltipEl, 'opacity', '0');
    this.renderer.setStyle(this.tooltipEl, 'pointer-events', 'none');
    this.renderer.setStyle(this.tooltipEl, 'transition', 'opacity .18s ease');

    icon.addEventListener("pointerenter", () => {
      if (this.hideTimeout) clearTimeout(this.hideTimeout);
      this.positionTooltip(icon);
      this.showTooltip();
    });

    icon.addEventListener("pointerleave", () => {
      this.scheduleHide();
    });

    this.tooltipEl.addEventListener("pointerenter", () => {
      if (this.hideTimeout) clearTimeout(this.hideTimeout);
      this.showTooltip();
    });

    this.tooltipEl.addEventListener("pointerleave", () => {
      this.scheduleHide();
    });
  }

  private showTooltip() {
    this.renderer.setStyle(this.tooltipEl, 'opacity', '1');
    this.renderer.setStyle(this.tooltipEl, 'pointer-events', 'auto');
  }

  private hideTooltip() {
    this.renderer.setStyle(this.tooltipEl, 'opacity', '0');
    this.renderer.setStyle(this.tooltipEl, 'pointer-events', 'none');
  }

  private scheduleHide() {
    if (this.hideTimeout) clearTimeout(this.hideTimeout);
    this.hideTimeout = setTimeout(() => this.hideTooltip(), 120);
  }

  private positionTooltip(iconEl: HTMLElement) {
    const rect = iconEl.getBoundingClientRect();
    const tool = this.tooltipEl;

    const spacing = 10;

    const left = rect.left - tool.clientWidth - spacing;
    const top = rect.top + rect.height / 2 - tool.clientHeight / 2;

    this.renderer.setStyle(tool, 'left', `${left}px`);
    this.renderer.setStyle(tool, 'top', `${top}px`);
  }


  //acessibilidade
  @ViewChild('accessibilityIcon', { static: true }) accessibilityIcon!: ElementRef;
  @ViewChild('accessibilityMenu', { static: true }) accessibilityMenu!: ElementRef;

  toggleAccessibility() {
    const menuElement = this.accessibilityMenu.nativeElement as HTMLElement;
    menuElement.style.display = menuElement.style.display === 'block' ? 'none' : 'block';
  }

  private readonly selectors =
    'p, h1, h2, h3, h4, h5, h6, span, a, li, button, label, input, textarea';

  private getElements(): HTMLElement[] {
    return Array.from(document.querySelectorAll(this.selectors)) as HTMLElement[];
  }

  private saveOriginalSize(el: HTMLElement): void {
    if (!el.dataset['originalFontSize']) {
      el.dataset['originalFontSize'] = window.getComputedStyle(el).fontSize;
    }
  }

  aumentarTexto(): void {
    this.getElements().forEach(el => {
      this.saveOriginalSize(el);

      const original = parseFloat(el.dataset['originalFontSize']!);
      el.style.fontSize = `${original * 1.1}px`;
    });
  }

  diminuirTexto(): void {
    this.getElements().forEach(el => {
      this.saveOriginalSize(el);

      const current = parseFloat(
        window.getComputedStyle(el).fontSize
      );

      el.style.fontSize = `${current - 0.5}px`;
    });
  }

  restaurarPadrao(): void {
    this.getElements().forEach(el => {
      const original = el.dataset['originalFontSize'];

      if (original) {
        el.style.fontSize = original;
        delete el.dataset['originalFontSize'];
      }
    });
  }

  darkColor = false;

  modetoggle() {
    this.darkColor = !this.darkColor;
    document.documentElement.setAttribute('data-theme', this.darkColor ? "darkTheme" : this.selectedColor);
    const button = document.getElementById('darkTheme');
    if (button) {
      button.title = this.darkColor ? 'Modo claro' : 'Modo escuro';
    }
  }

  selectedColor: string = "light";

  setColor(color: string) {
    this.selectedColor = color;
    document.documentElement.setAttribute('data-theme', color);
  }

  grey() { this.setColor("grey"); }
  blue() { this.setColor("blue"); }
  green() { this.setColor("green"); }
  red() { this.setColor("red"); }
  yellow() { this.setColor("yellow"); }
  pink() { this.setColor("pink"); }

  restaurarCor() {
    document.documentElement.setAttribute('data-theme', this.selectedColor);
  }

  private hostEl!: HTMLElement;

  ngOnDestroy() {
    try {
      if (this.hostEl && this.hostEl.parentNode === document.body) {
        this.renderer.removeChild(document.body, this.hostEl);
      }
    } catch { }

    try {
      if (this.tooltipEl && this.tooltipEl.parentNode === document.body) {
        this.renderer.removeChild(document.body, this.tooltipEl);
      }
    } catch { }
  }

  @HostListener('window:scroll')
  onScroll(): void {
    this.showBotaoTopo = window.scrollY > 100;
  }

  voltarAoTopo(): void {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}
